import { api } from "./api";

const actions = {
	getAssistantsForAccount: (accountID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/assistants/account/${accountID}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	getAssistantResources: (accountID, assistantID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "GET",
					url: `/api/v1/assistants/resource/${accountID}/${assistantID}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	checkBijectionAssistantResource: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					data,
					url: `/api/v1/assistants/resource/checkBijection`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Fetch full Mongo documents for items flagged by the data check (drill-down).
	 * @param {String} assistantID
	 * @param {Object} body - { type: "source" | "knowledge", ids: string[] }
	 */
	dataCheckDetails: (assistantID, body, onSuccess = () => {}, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/checkBijection/dataCheck/${assistantID}/details`,
					data: body,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure
				})
			);
		};
	}
};

export default actions;
